import { initializeApp } from 'firebase/app';

export const environment = {
  production: false,
  app_config:{
    domain : "stage.admin.farmlink.in",
    domain_type: "https"
  },
   firebaseConfig : {
    apiKey: "AIzaSyDSRGY31tFi9xfWBT6yThwJ1vSYNeUGVjE",
    authDomain: "districo-vendor.firebaseapp.com",
    databaseURL: "https://districo-vendor-default-rtdb.firebaseio.com",
    projectId: "districo-vendor",
    storageBucket: "districo-vendor.appspot.com",
    messagingSenderId: "1035431527070",
    appId: "1:1035431527070:web:74599bb01e161b63a4718f",
    measurementId: "G-KSCW4M3J0G"
  }
};

export const app  = initializeApp(environment.firebaseConfig);
